import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface LandingLayoutProps {
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}

/** Page shell: skip-link, sticky header slot, main landmark, footer slot. */
export function LandingLayout({ header, footer, children }: LandingLayoutProps) {
  const { t } = useTranslation();
  return (
    <Box bg="white" color="onboarding.deepPlum" fontFamily="body" minH="100vh">
      <Box
        as="a"
        href="#main"
        position="absolute"
        left={3}
        top={3}
        zIndex={100}
        px={3}
        py={2}
        bg="white"
        color="onboarding.plum"
        borderRadius="md"
        fontWeight={600}
        transform="translateY(-150%)"
        _focus={{ transform: 'translateY(0)' }}
      >
        {t('landing.a11y.skipToContent')}
      </Box>
      {header}
      <Box as="main" id="main">
        {children}
      </Box>
      {footer}
    </Box>
  );
}
